<p>dialog-detalle-propiedad works!</p>
